export default {"src":"/_next/static/media/email.995a2cc4.svg","height":32,"width":32};